import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { acceptFlashDiscount, acceptFlashDiscountMutationKey, IAcceptFlashDiscountBody } from '../api/accept-flash-discount';

export default function useAcceptFlashDiscount(options?: Pick<UseMutationOptions<any, any, IAcceptFlashDiscountBody, any>, 'onSuccess' | 'onError' | 'onSettled' | 'onMutate'>) {
  return useMutation({
    mutationKey: acceptFlashDiscountMutationKey(),
    mutationFn: acceptFlashDiscount,

    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context);
    },
    onSettled: (data, error, variables, context) => {
      options?.onSettled?.(data, error, variables, context);
    },
    onMutate: (variables) => {
      options?.onMutate?.(variables);
    },

    retry: false,
  });
}
